import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Nav from "@/components/aix/Nav";
import { Footer } from "@/components/aix/Sections2";
import { ARTICLES, formatDate } from "@/data/articles";

export default function Blog() {
  useEffect(() => {
    document.title = "The Dispatch — AI Advantage Exchange";
    return () => {
      document.title = "AI Advantage Exchange — Curated AI Professional Community";
    };
  }, []);

  return (
    <div className="bg-white text-slate-900 min-h-screen antialiased" data-testid="blog-page">
      <Nav />
      <main className="max-w-6xl mx-auto px-6 py-20 md:py-28">
        <span className="font-mono-lbl text-xs text-aix-cyandeep tracking-widest uppercase">THE DISPATCH</span>
        <h1 className="font-display text-4xl md:text-5xl font-black tracking-tight text-slate-900 mt-2 mb-14" data-testid="blog-headline">
          Field notes on building AI software
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {ARTICLES.map((a) => (
            <Link
              key={a.slug}
              to={`/blog/${a.slug}`}
              className="border border-slate-200 bg-white shadow-sm rounded-xl p-6 flex flex-col hover:border-aix-cyan/60 hover:shadow-md transition-all group"
              data-testid={`blog-card-${a.slug}`}
            >
              <div className="h-40 -mx-6 -mt-6 mb-5 rounded-t-xl overflow-hidden">
                <img
                  src={a.image}
                  alt={a.imageAlt}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <span className="font-mono-lbl text-[10px] text-aix-cyandeep tracking-widest uppercase mb-3">
                {a.category} · {formatDate(a.date)}
              </span>
              <h2 className="font-display text-xl font-bold text-slate-900 mb-3 leading-snug">{a.title}</h2>
              <p className="text-slate-500 text-sm leading-relaxed mb-6 flex-grow">{a.excerpt}</p>
              <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-aix-navy group-hover:text-[#16407F]">
                Read article <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
              </span>
            </Link>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
